import { useEffect, useRef } from "react";
import { setCanvasSize } from "helpers/mathFunctions";
import { useCanvasStore } from "store/CanvasStore";
const Canvas = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { initializeCanvas } = useCanvasStore();

  useEffect(() => {
    const canvas = canvasRef.current as HTMLCanvasElement;
    const context = canvas?.getContext("2d");
    if (context) {
      const resolution = setCanvasSize();

      canvas.width = resolution.width;
      canvas.height = resolution.height;

      initializeCanvas(canvas, context);
    }
  }, []);

  return <canvas ref={canvasRef} />;
};

export default Canvas;
